export default "__VITE_ASSET__B4widj5i__"